<template>
<div class="daoh2">
    <div class="ti">
       <transition>
        <keep-alive>
            <router-view></router-view>
        </keep-alive>
       </transition>
    </div>
</div>
</template>
<script>
export default {
  name: 'ConsultIndex',
  data () {
    return {
      isCollapse: false,
      item:[],
      items_list1:[
          {
            id:'1010201',
            label: '咨询管理',
            icon: 'mdi-home-outline ',
            path:'/Consult/Consult',
            pid:101020,
          },
          {
            id:'1010202',
            label: '暂挂审核',
            icon: 'mdi-home-outline ',
            path:'/Consult/Cowarning',
            pid:101020,
          },
          {
            id:'1010203',
            label: '预警设置',
            icon: 'mdi-home-outline ',
            path:'/Consult/Coending',
            pid:101020,
          },
      ],
    }
  },
  //界面没出来前加载
  created() {
    this.$myhttp.get('admin/lavel2?pid=101020',{
      'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
        if(backdata.data != 1){
          this.item = backdata.data;
        }else{
          this.item = this.items_list1;
        }
        // console.log(backdata.data)
      });
    },
}
</script>
<style scoped>
.daoh2{
    display: flex;
    height: 100%;
}
 .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 100px;
    height: 100%;
  }
  a{
      text-decoration: none;
   }
   .ti{
    height: 100%;
    width: 100%;
    background-color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/App/Consult/Index.vue